<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="mt-2 col-md-12"></div>

    <div class="margen">
      <div class="row">
        <div class="col-md-6 text-left">
          <div
            class="alert alert-primary"
            role="alert"
            v-if="diagnosticador != null"
          >
            Información PTI
          </div>
          <div class="alert alert-warning" role="alert" v-else>
            Información PTI
          </div>

          <div class="inline">
            <p class="etiqueta">Diagnosticador: {{ diagnosticador }}</p>
          </div>

          <div class="inline">
            <p class="etiqueta">Doctor: {{ doctor }}</p>
          </div>

          <div class="inline">
            <p class="etiqueta">Fecha del PTI: {{ fecha }}</p>
          </div>

          <div class="inline">
            <p class="etiqueta">Nivel de PTI: {{ nivel }}</p>
          </div>

          <div class="inline">
            <p class="etiqueta">
              <b-link :to="{ name: 'treatment', params: { pti: 1 } }"
                >Opciónes generadas del PTI:</b-link
              >
              <span v-for="(opcion, index) in opcionesGeneradas" :key="index">
                <span>{{ opcion }}</span>
                <span v-if="index + 1 < opcionesGeneradas.length">,</span>
              </span>
            </p>
          </div>

          <div class="inline">
            <p class="etiqueta">
              <b-link :to="{ name: 'nuevopti' }"
                >Opción de PTI aceptada:</b-link
              >
              <span v-for="(opcion, index) in opcionAceptada" :key="index">
                <span>{{ opcion }}</span>
                <span v-if="index + 1 < opcionAceptada.length">,</span>
              </span>
            </p>
          </div>

          <!-- <div class="inline">
            <p class="etiqueta">Monto de PTI aceptado: {{monto}}</p>
          </div>-->
        </div>

        <div class="col-md-6 text-left">
          <div
            class="alert alert-primary"
            role="alert"
            v-if="diagnosticadorReplica != null"
          >
            Información Réplica:
          </div>

          <div class="alert alert-warning" role="alert" v-else>
            Información Réplica:
          </div>

          <div class="inline">
            <p class="etiqueta">Diagnosticador: {{ diagnosticadorReplica }}</p>
          </div>

          <div class="inline">
            <p class="etiqueta">Doctor: {{ doctorReplica }}</p>
          </div>

          <div class="inline">
            <p class="etiqueta">
              <b-link :to="{ name: 'patient', params: { id: 1 } }"
                >Tratamientos</b-link
              >
            </p>
          </div>
        </div>
      </div>
    </div>
    <div id="frame" class="container-fluid">
      <div class="row justify-content-center">
        <div id="informacionDiagnostico" class="col-sm-8 col-12">
          <div id="colInformacionDiagnostico"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "resumenPTI",
  components: {},
  props: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    idPaciente: "",
    ptiId: null,
    diagnosticador: null,
    doctor: null,
    fecha: null,
    nivel: null,
    opcionesGeneradas: [],
    opcionAceptada: [],
    monto: 50000,
    diagnosticadorReplica: null,
    doctorReplica: null,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.idPaciente = this.$route.params.id;
  },
  mounted() {
    this.getResumenInformacionPTI();
    this.getResumenOpcionesPTIGeneradas();
    this.getResumenOpcionPTIAceptada();
    this.getResumenInformacionReplica();
  },
  methods: {
    //  ----------------------------
    getResumenInformacionPTI() {
      const parametros = {idPaciente: this.idPaciente}
      this.$http
        .post(
          this.$api +
            "resumenpti/obtener/informacion/pti", parametros
        )
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            var data = response.data.data;

            data.forEach((elemento) => {
              this.diagnosticador = elemento.diagnosticador;
              this.doctor = elemento.doctor;
              this.fecha = elemento.fecha_pti;
              this.nivel = elemento.nivel_pti;
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },

    // ---------------
    getResumenOpcionesPTIGeneradas() {
      const parametros = {idPaciente: this.idPaciente}
      this.$http
        .post(
          this.$api +
            "resumenpti/obtener/opciones/generadas/pti", parametros
        )
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            this.opcionesGeneradas = response.data.data;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    //  ----------------------------
    getResumenOpcionPTIAceptada() {
      const parametros = {idPaciente: this.idPaciente}
      this.$http
        .post(
          this.$api +
            "resumenpti/obtener/opcion/pti/aceptada", parametros
        )
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            this.opcionAceptada = response.data.data;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getResumenInformacionReplica() {
      /*this.$http
        .get(
          this.$api +
            "resumenpti/obtener/informacion/replica?idPaciente=" +
            this.idPaciente
        )
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            var data = response.data.data;

            data.forEach((elemento) => {
              this.diagnosticadorReplica = elemento.diagnosticador;
              this.doctorReplica = elemento.doctor;
            });
          }
        })
        .catch((error) => {
          alert("errorr");
          console.error(error);
        });*/
    },

    //  ----------------------------
  },
};
</script>

<style scoped>
.margen {
  display: inline-block;
  width: 90%;
}
</style>
